export default __webpack_public_path__ + "static/media/Opay.63c8026d.png";